import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CurrencyPipe } from '@angular/common';
import { MatStepper } from '@angular/material/stepper';

import { ComponentBase, DialogService, LanguageService, Mandant, MandantAuthService, UserAuthService, WebFrameworkService } from '@definitiv-packages/angular-dba-library';
import { DocumentService } from '@definitiv-packages/angular-documents-library';

import { AppService, ProjectLanguage, ProjektPermissionService, SafetyPointFormModelView, SafetyPointFormModelViewService } from '../../../../../roofsafetymanagement-library/src/public-api';

@Component({
  selector: 'app-create-safetypointform-dialog',
  templateUrl: './create-safetypointform-dialog.component.html',
  styleUrls: ['./create-safetypointform-dialog.component.scss'],
  standalone: false
})
export class CreateSafetyPointFormDialogComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  public Title: string = "";
  public checkBoxFeldList: any[] = [];

  public signaturLoeschen: boolean = false;
  public userhassigned: boolean = false;
  public darfBemerekunganlegen: boolean = false;
  public signaturBeheben: Boolean = false;
  public formDisabled: boolean = true;
  public saveClicked: boolean = false;
  public UserIsAdmin: boolean = false;
  public AdminNotizenArray: { id: number; value: string }[] = [];
  public SafetyPointFormNotizenArray: [] = [];
  public FormGroup = new UntypedFormGroup({

  });

  @ViewChild('stepper') private myStepper: MatStepper | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: SafetyPointFormModelView,
    private dialog: MatDialogRef<CreateSafetyPointFormDialogComponent>,
    private currencyPipe: CurrencyPipe,
    private dialogService: DialogService,
    private webFrameworkService: WebFrameworkService,
    private mandantService: MandantAuthService,
    private userAuthService: UserAuthService,
    private documentservice: DocumentService,
    private safetyPointFormModelViewService: SafetyPointFormModelViewService,
    private appService: AppService,
    public permission: ProjektPermissionService,
  ) { super(); }

  public async ngOnInit(): Promise<void> {
    this.loading = true;

    var res = this.safetyPointFormModelViewService.getFilteredList({ SafetyPointId: 1 })
    this.UserIsAdmin = this.appService.isUserAdmin();
    this.Title = "";
    //   var res = await this.formularViewService.getList();
  }

}
